// @generated by protoc-gen-es v2.11.0 with parameter "target=ts+js"
// @generated from file lease/kiosk/v1/types.proto (package lease.kiosk.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_lease_common_v1_types } from "../../common/v1/types_pb";

/**
 * Describes the file lease/kiosk/v1/types.proto.
 */
export const file_lease_kiosk_v1_types = /*@__PURE__*/
  fileDesc("ChpsZWFzZS9raW9zay92MS90eXBlcy5wcm90bxIObGVhc2Uua2lvc2sudjEiTQoHUHJvZHVjdBIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhUKDWRpc3BsYXlfcHJpY2UYAyABKAkSEQoJaW1hZ2VfdXJsGAQgASgJIq8CCgRJdGVtEgoKAmlkGAEgASgJEigKB3Byb2R1Y3QYAiABKAsyFy5sZWFzZS5raW9zay52MS5Qcm9kdWN0EhQKDHByb2R1Y3RfbmFtZRgDIAEoCRIVCg1kaXNwbGF5X3ByaWNlGAQgASgJEhEKCWltYWdlX3VybBgFIAEoCRIRCglhdmFpbGFibGUYBiABKAgSFgoOcHJpY2VfaW5fY2VudHMYByABKAUSHQoVaG9tZV9sb2NhdGlvbl9kaXNwbGF5GAggASgJEhgKEGhvbWVfbG9jYXRpb25faWQYCSABKAUSKAoFc3RhdGUYCiABKA4yGS5sZWFzZS5raW9zay52MS5JdGVtU3RhdGUSEAoIZm9yX3NhbGUYCyABKAgSEQoJc3RhY2thYmxlGAwgASgIItYCCgVPcmRlchIKCgJpZBgBIAEoCRIiCgRpdGVtGAIgASgLMhQubGVhc2Uua2lvc2sudjEuSXRlbRIrCgZzdGF0dXMYAyABKA4yGy5sZWFzZS5raW9zay52MS5PcmRlclN0YXR1cxIuCgpjcmVhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIrCgdwYWlkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgxkaXNwZW5zZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi8KC3JldHVybmVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgthdXRoX21ldGhvZBgIIAEoDjIbLmxlYXNlLmNvbW1vbi52MS5BdXRoTWV0aG9kIrYBCglJdGVtSW5Vc2USJAoFb3JkZXIYASABKAsyFS5sZWFzZS5raW9zay52MS5PcmRlchIiCgRpdGVtGAIgASgLMhQubGVhc2Uua2lvc2sudjEuSXRlbRIuCgpjcmVhdGVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgtyZXR1cm5lZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiqQIKElBheW1lbnRJbmZvcm1hdGlvbhINCgVsYXN0NBgBIAEoCRILCgNhaWQYAiABKAkSCwoDcnJuGAMgASgJEhIKCmNhcmRfYnJhbmQYBCABKAkSGAoQYXBwbGljYXRpb25fbmFtZRgFIAEoCRILCgNhdGMYBiABKAkSEwoLZmFpbF9yZWFzb24YByABKAkSIQoZcGF5bWVudF9kZXZpY2Vfc2Vzc2lvbl9pZBgIIAEoCRIeChZwYXltZW50X3RyYW5zYWN0aW9uX2lkGAkgASgJEhwKFHByZWF1dGhfYW1vdW50X2NlbnRzGAogASgDEhoKEnByZWF1dGhfZXhwaXJlc19hdBgLIAEoAxIdChVwYXltZW50X2RldmljZV9zZXJpYWwYDCABKAkqkQEKCUl0ZW1TdGF0ZRIaChZJVEVNX1NUQVRFX1VOU1BFQ0lGSUVEEAASFAoQSVRFTV9TVEFURV9SRUFEWRABEhUKEUlURU1fU1RBVEVfSU5fVVNFEAISFwoTSVRFTV9TVEFURV9SRVRVUk5FRBADEiIKHklURU1fU1RBVEVfUEVORElOR19JTlNUUEVDVElPThAEKqcDCgtPcmRlclN0YXR1cxIcChhPUkRFUl9TVEFUVVNfVU5TUEVDSUZJRUQQABIgChxPUkRFUl9TVEFUVVNfUEVORElOR19QQVlNRU5UEAESJAogT1JERVJfU1RBVFVTX0FVVEhPUklTSU5HX1BBWU1FTlQQAhIjCh9PUkRFUl9TVEFUVVNfQVVUSE9SSVNFRF9QQVlNRU5UEAsSFQoRT1JERVJfU1RBVFVTX1BBSUQQAxIoCiRPUkRFUl9TVEFUVVNfUEVORElOR19QQVlNRU5UX1RJTUVPVVQQBBIgChxPUkRFUl9TVEFUVVNfUEFZTUVOVF9GQUlMVVJFEAUSGgoWT1JERVJfU1RBVFVTX0RJU1BFTlNFRBAGEiEKHU9SREVSX1NUQVRVU19ESVNQRU5TRV9GQUlMVVJFEAcSGQoVT1JERVJfU1RBVFVTX0NBTkNFTEVEEAgSIgoeT1JERVJfU1RBVFVTX1ZJUlRVQUxfRlVMRklMTEVEEAkSLAooT1JERVJfU1RBVFVTX1ZJUlRVQUxfRlVMRklMTE1FTlRfRkFJTFVSRRAKQjtaOWdpdGh1Yi5jb20vdmVuZGluZ29udHJhY2svYXBpL2dvLWdlbi9sZWFzZS9raW9zay92MTtraW9za2IGcHJvdG8z", [file_google_protobuf_timestamp, file_lease_common_v1_types]);

/**
 * Describes the message lease.kiosk.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_types, 0);

/**
 * Describes the message lease.kiosk.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_types, 1);

/**
 * Describes the message lease.kiosk.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_types, 2);

/**
 * Describes the message lease.kiosk.v1.ItemInUse.
 * Use `create(ItemInUseSchema)` to create a new message.
 */
export const ItemInUseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_types, 3);

/**
 * Describes the message lease.kiosk.v1.PaymentInformation.
 * Use `create(PaymentInformationSchema)` to create a new message.
 */
export const PaymentInformationSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_types, 4);

/**
 * Describes the enum lease.kiosk.v1.ItemState.
 */
export const ItemStateSchema = /*@__PURE__*/
  enumDesc(file_lease_kiosk_v1_types, 0);

/**
 * @generated from enum lease.kiosk.v1.ItemState
 */
export const ItemState = /*@__PURE__*/
  tsEnum(ItemStateSchema);

/**
 * Describes the enum lease.kiosk.v1.OrderStatus.
 */
export const OrderStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_kiosk_v1_types, 1);

/**
 * @generated from enum lease.kiosk.v1.OrderStatus
 */
export const OrderStatus = /*@__PURE__*/
  tsEnum(OrderStatusSchema);

